import * as React from "react";

import { FieldTextGroup, Flex } from "@theorgchartdev/storybook";
import SectionCard, { SectionCardGroup } from "../../../../Composites/SectionCard/SectionCard";
import { useEffect } from "react";
import { GetWSMgr } from "@/Utils/StateLib";
import { appstr } from "@coreapp/utils/appstr";

export const UserDetails = () => {
  const wsMgr = GetWSMgr();

  useEffect(() => {
    const eventTracker = wsMgr.GetUsageTracker();
    eventTracker.ReportEvent("account_settings.user_details.opened");
  }, []);

  const addFieldText = (field, value, data) => {
    data.push({ field: field, value: value });
  };

  const getData = () => {
    const accessGroupMgr = wsMgr.GetAccessGroupMgr();
    const username = wsMgr.GetUserName();
    const email = wsMgr.GetUserEmail();
    const accessGroup = wsMgr.fUserInfo.GetUserGroupID();
    const groupName = accessGroupMgr.GetGroupNameByID(accessGroup);
    const role = wsMgr.fUserInfo.GetUserRole();

    const data = [];
    addFieldText(appstr("userid"), username, data);
    addFieldText(appstr("Email"), email, data);
    addFieldText(appstr("accessgroup"), groupName, data);
    addFieldText(appstr("accounttype"), role, data);
    return data;
  };

  return (
    <SectionCardGroup>
      <SectionCard title={appstr("userdetails")}>
        <Flex direction={"column"} gap={"8px"} height={"100%"}>
          <FieldTextGroup columnGap={16} columns={1} data={getData()} size={"large"} />
        </Flex>
      </SectionCard>
    </SectionCardGroup>
  );
};
